import React from "react";

import PrimaryButton from "../../../../../components/buttons/PrimaryButton";
import { useModalContext } from "../../../../../providers/modal/modal.provider";
import ModalHeader from "../../../../../components/claims/components/ModalHeader";
import ModalBody from "../../../../../components/claims/components/ModalBody";
import { useCreateUsedContext } from "../provider/createUsed.provider";
import { useCreateContext } from "../../provider/create.provider";
import { IUseCreatePolicyAgents } from "../../../../../services/microservice/micelu/create/use-create-micelu.interface";
import { usePreCreatePolicyAgents } from "../../../../../services/microservice/agents/policy/use-policy-agents";

const ReviewComponentStep = () => {
  const {
    infoPlanDevice,
    setStep,
    setClient,
    setInfoPlanDevice,
    handleInitialState,
  } = useCreateUsedContext();
  const { setStep: setStepGeneral } = useCreateContext();
  const { mutateAsync: preCreate, isLoading } = usePreCreatePolicyAgents();
  const { setShow } = useModalContext();

  const clearProcess = () => {
    handleInitialState();
    setStepGeneral(3);
    setShow((prevState) => ({
      ...prevState,
      visible: false,
    }));
  };

  const onSubmit = async () => {
    const data = {
      planID: infoPlanDevice?.planID,
      documentNumber: infoPlanDevice?.documentNumber,
      listImei: infoPlanDevice?.listImeis,
      sponsorID: "ENEL",
    };

    try {
      const res = await preCreate(data);
      if (res) {
        setShow((prevState) => ({
          ...prevState,
          visible: true,
          header: <ModalHeader success={true} />,
          content: (
            <ModalBody
              title="Póliza exitosa"
              message={`La póliza se guardo exitosamente`}
            />
          ),
          onAccept: clearProcess,
          titleOnAccept: "Aceptar",
          withClass: "flex",
          showBtnAccept: true,
        }));
      }
    } catch (error) {
      if (error.response.status === 400) {
        setShow((prevState) => ({
          ...prevState,
          visible: true,
          header: <ModalHeader success={false} />,
          content: (
            <ModalBody
              title=" No fue posible guardar la póliza"
              message={error?.response.data.error.message}
            />
          ),
          onAccept: clearProcess,
          titleOnAccept: "Aceptar",
          withClass: "flex",
          showBtnAccept: true,
        }));
      } else {
        setShow((prevState) => ({
          ...prevState,
          visible: true,
          header: <ModalHeader success={false} />,
          content: (
            <ModalBody
              title=" No fue posible guardar la póliza"
              message="Acaba de ocurrir un problema, lo sentimos."
            />
          ),
          onAccept: clearProcess,
          titleOnAccept: "Aceptar",
          withClass: "flex",
          showBtnAccept: true,
        }));
      }
    }
  };

  const handlePreviousStep = () => {
    setStep((prev) => prev - 1);
    setInfoPlanDevice(null);
    setClient(null);
  };

  return (
    <section className="w-full">
      <h2 className="mb-5 text-center text-3xl font-bold">
        <span>Confirmación</span>
      </h2>
      <div className="mx-auto grid w-1/2 grid-cols-1 gap-0 pt-10">
        <table className="textSecondary table w-full">
          <tbody>
            <tr>
              <td className="border-t-0">
                <h6 className="text-buttonBlack mb-4 font-medium">
                  Datos cliente{" "}
                </h6>
              </td>
              <td className="border-t-0 border-b-0 pt-1 pb-3 text-end">
                &nbsp;
              </td>
            </tr>
            <tr>
              <td className="border-t-0 border-b-0 pt-1 pb-3">
                Número de documento:
              </td>
              <td className="border-t-0 border-b-0 pt-1 pb-3 text-end">
                {(infoPlanDevice as any)?.documentNumber}
              </td>
            </tr>
            <tr>
              <td className="border-t-0">&nbsp;</td>
            </tr>
            <tr className="h-10">
              <td className="w-full" colSpan={1}>
                <h6 className="text-buttonBlack mb-4 font-medium">
                  Dispositivos
                </h6>
              </td>
            </tr>

            {(infoPlanDevice as any).imei1 && (
              <tr>
                <td className="border-t-0 border-b-0 pt-1 pb-3">
                  Dispositivo 1:
                </td>
                <td className="border-t-0 border-b-0 pt-1 pb-3 text-end">
                  {(infoPlanDevice as any)?.imei1}
                </td>
              </tr>
            )}
            {(infoPlanDevice as any).imei2 && (
              <tr>
                <td className="border-t-0 border-b-0 pt-1 pb-3">
                  Dispositivo 2:
                </td>
                <td className="border-t-0 border-b-0 pt-1 pb-3 text-end">
                  {(infoPlanDevice as any)?.imei2}
                </td>
              </tr>
            )}
            {(infoPlanDevice as any).imei3 && (
              <tr>
                <td className="border-t-0 border-b-0 pt-1 pb-3">
                  Dispositivo 3:
                </td>
                <td className="border-t-0 border-b-0 pt-1 pb-3 text-end">
                  {(infoPlanDevice as any)?.imei3}
                </td>
              </tr>
            )}
            {(infoPlanDevice as any).imei4 && (
              <tr>
                <td className="border-t-0 border-b-0 pt-1 pb-3">
                  Dispositivo 4:
                </td>
                <td className="border-t-0 border-b-0 pt-1 pb-3 text-end">
                  {(infoPlanDevice as any)?.imei4}
                </td>
              </tr>
            )}

            <tr>
              <td className="border-t-0">&nbsp;</td>
            </tr>
            <tr>
              <td className="border-t-0">
                <h6 className="text-buttonBlack font-medium">
                  Datos del plan
                </h6>
              </td>
              <td className="border-t-0">&nbsp;</td>
            </tr>
            <tr>
              <td className="border-t-0 border-b-0">Nombre del plan</td>
              <td className="border-t-0 border-b-0 text-end">
                {(infoPlanDevice as any)?.plan?.nombre}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="mt-5 flex w-full justify-between">
        <PrimaryButton
          title="Atrás"
          type="button"
          className={"text-textBlack mt-5 rounded-3xl border px-5 py-1"}
          style={{ borderColor: "#0a0a0a" }}
          onClick={() => handlePreviousStep()}
        />
        <PrimaryButton
          title="Asegurar"
          className={
            "bg-buttonBlack text-whiteSoft mt-5 rounded-3xl px-5 py-1 text-sm font-normal"
          }
          onClick={() => onSubmit()}
          loading={isLoading}
        />
      </div>
    </section>
  );
};

export default ReviewComponentStep;
